import { render, staticRenderFns } from "./TemporaryOrder.vue?vue&type=template&id=6bbefac2"
import script from "./TemporaryOrder.vue?vue&type=script&lang=js"
export * from "./TemporaryOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports